// extracted by mini-css-extract-plugin
module.exports = {"nodesContainer":"dashboard-nodes_nodesContainer__LAT63","brandIcon":"dashboard-nodes_brandIcon__XybkL"};